/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'

// Components
import {
    Flex,
    IconButton,
    // Hooks
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'

// constants
import {SOCIAL_MEDIA_INSTAGRAM, SOCIAL_MEDIA_FACEBOOK} from '../../constants'

// Icons
import {SocialInstagramIcon, SocialFacebookIcon} from '../icons'

/**
 *
 */
const SocialIcons = ({variant, ...otherProps}) => {
    const styles = useMultiStyleConfig('SocialIcons', {variant})
    const socialLinks = []
    if (SOCIAL_MEDIA_INSTAGRAM) {
        socialLinks.push({
            href: SOCIAL_MEDIA_INSTAGRAM,
            icon: SocialInstagramIcon,
            ariaLabel: 'Instagram'
        })
    }
    if (SOCIAL_MEDIA_FACEBOOK) {
        socialLinks.push({
            href: SOCIAL_MEDIA_FACEBOOK,
            icon: SocialFacebookIcon,
            ariaLabel: 'Facebook'
        })
    }

    return (
        <Flex className="sf-social-icons" {...styles.container} {...otherProps}>
            {/* Social Links */}
            {socialLinks.map(({href, icon, ariaLabel}) => (
                <IconButton
                    {...styles.item}
                    key={href}
                    icon={React.createElement(icon, styles.icon)}
                    variant="unstyled"
                    onClick={() => {
                        window.open(href)
                    }}
                    aria-label={ariaLabel}
                    title={ariaLabel}
                />
            ))}
        </Flex>
    )
}

SocialIcons.displayName = 'SocialIcons'

SocialIcons.propTypes = {
    /**
     * This component has 3 variants, 'flex', 'flex-start' and 'flex-end'.
     * All will affect how the child icons are displayed. By default, it's
     * value is `flex`.
     */
    variant: PropTypes.string
}

export default SocialIcons
